import { getLicensePage } from '@/api/license/licenseApi';
import { useFetchPage } from '@/composition/fetch';
import { defineComponent, toRefs, watch } from 'vue';
import moment from 'moment';
export default defineComponent({
    props: {
        companyId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const { companyId } = toRefs(props);
        const { state, request } = useFetchPage(getLicensePage);
        watch(companyId, (companyId) => {
            request({ companyId, size: 9999 });
        }, { immediate: true });
        const { data, loading } = toRefs(state);
        const headers = [
            { text: 'Seq', value: 'liSeq', sortable: false },
            { text: 'ProductName', value: 'productName' },
            { text: 'License Count', value: 'licenseCount' },
            { text: 'End Date', value: 'endDate' },
            { text: 'Status', value: 'status' },
            { text: 'Detail', value: 'detail' }
        ];
        return {
            headers,
            data,
            loading,
            isExpired(date) {
                return moment(date).isBefore(moment().add(-1, 'd'));
            }
        };
    }
});
